import { useQuery } from '@tanstack/react-query';
import {
  ACCOUNT_SETTINGS_DEFAULTS,
  accountSettingsQueryOptions,
  type AccountSettings,
} from '@/api/queries/settings';

export interface UseSettingsResult {
  settings: AccountSettings;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Bulk reader for the whole account settings document, for the settings screen
 * and the rare consumer that needs many keys at once. For a single value prefer
 * `useSetting(key)`, which slices and only re-renders on that key's change.
 */
export function useSettings(): UseSettingsResult {
  const { data, isLoading, isError } = useQuery(accountSettingsQueryOptions());

  return {
    settings: data ?? ACCOUNT_SETTINGS_DEFAULTS,
    isLoading,
    isError,
  };
}
